export default "__VITE_ASSET__smih5fQE__"